import script from "./ReviewMigrationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewMigrationStep.vue?vue&type=script&setup=true&lang=js"

import "./ReviewMigrationStep.vue?vue&type=style&index=0&id=ff60e1dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff60e1dc"]])

export default __exports__